import React, { useEffect, useRef, useState } from 'react';
import { Button, Form, Spinner } from 'react-bootstrap';
import { FileUploader } from 'react-drag-drop-files';
import PhoneInput, { parsePhoneNumber } from 'react-phone-number-input';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import validator from 'validator';
import CustomAlert from '../../../components/CustomAlert';
import config from '../../../config/Constant';
import { getRequest, postRequest, uploadFile } from '../../../helpers/apiHandler';
import { getTimezone } from '../../../helpers/helperFunction';
import { setLoginSuccess } from '../../../store/actions/reduxAction';
import { reloadTopbar } from '../../../store/actions/reduxAction';
import ChangeMobileNumberModal from './ChangeMobileNumberModal';

const white_label_perkeso = process.env.REACT_APP_WHITE_LABEL_PERKESO === 'true';

const UserProfile = () => {
  const dispatch = useDispatch();
  const { email: user_email, name, phone_number, country, timezone: user_tz, currency: currency_code, access_token } = useSelector((state) => state.auth.user)

  const user_country = { value: country, label: country };
  const getSelectedTZ = getTimezone().filter((x) => x.value === user_tz);
  const isCountryChanged = useRef(false);

  const [loadingSave, setLoadingSave] = useState(false);
  const [selectedFile, setSelectedFile] = useState();
  const [email, setEmail] = useState(user_email);
  const [firstName, setFirstName] = useState(name);
  const [country_options, setCountry_options] = useState(false);
  const [selected_country, setSelected_country] = useState(user_country);
  const [phoneNumber, setPhoneNumber] = useState(phone_number);
  const [timezone, setTimezone] = useState(getSelectedTZ);
  const [currency, setCurrency] = useState(currency_code.iso3);
  const [showChangeModal, setShowChangeModal] = useState(false);

  const [emailError, setEmailError] = useState({
    error: false,
    message: '',
  });
  const [firstNameError, setFirstNameError] = useState({
    error: false,
    message: '',
  });
  const [phoneNumberError, setPhoneNumberError] = useState({
    error: false,
    message: '',
  });
  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'danger',
    message: '',
  });

  const get_countries = async () => {
    const data = {
      headers: { Authorization: access_token?.token },
    };
    getRequest('/v2/country-all', data, (res) => {
      if (res.success) {
        const { data } = res;

        const country_options = data.map(item => ({
          value: item.iso2,
          label: `${item.name} (${item.iso2})`,
        }));
        setCountry_options(country_options)
      }
    });
  }

  useEffect(() => {
    get_countries()
  }, [])


  const handleUploadProfilePic = async (file) => {
    setSelectedFile(file)

    uploadFile('/v2/upload-picture', file, access_token.token, (res) => {
      if (res.success) {
        dispatch(reloadTopbar());
        setAlertState({
          message: 'Your profile image has been successfully uploaded.',
          show: true,
          variant: 'success',
        });
        setSelectedFile(null)
      }
    });
  };

  const handleEditProfileSubmit = (evt) => {
    evt.preventDefault();
    const form = evt.currentTarget;

    if (form.checkValidity() === false) {
      evt.stopPropagation();
    }

    if (validator.isEmpty(email)) {
      setEmailError({
        error: true,
        message: 'Please enter your email address',
      });
      return;
    }

    if (!validator.isEmail(email)) {
      setEmailError({
        error: true,
        message: 'Email is invalid!',
      });
      return;
    }

    if (validator.isEmpty(firstName)) {
      setFirstNameError({
        error: true,
        message: 'Please enter your name',
      });
      return;
    }

    if (!validator.matches(firstName, /^[a-zA-Z ]+$/)) {
      setFirstNameError({
        error: true,
        message: 'Your name must not contain numbers',
      });
      return;
    }

    if (!validator.isLength(firstName, { min: 1, max: 30 })) {
      setFirstNameError({
        error: true,
        message: 'Name must not exceed 30 characters',
      });
      return;
    }

    setLoadingSave(true);
    const data = {
      email: email,
      first_name: firstName,
      country: selected_country.value,
      phone_number: phoneNumber,
      timezone: timezone.value,
      currency: currency,
    };

    postRequest('/v2/profile-settings-update', data, access_token.token, (res) => {
      if (res.success) {
        setLoadingSave(false);
        dispatch(setLoginSuccess(res));
        dispatch(reloadTopbar());
        setAlertState({
          message: 'Your changes have successfully been saved!',
          show: true,
          variant: 'success',
        });
      } else {
        setLoadingSave(false);
        setAlertState({
          message: res.message,
          show: true,
          variant: 'danger',
        });
      }
    });
  };

  useEffect(() => {
    if (alertState.show) {
      setTimeout(() => {
        setAlertState({
          message: '',
          show: false,
          variant: '',
        });
      }, config.notify_time);
    }
  }, [alertState]);

  return (
    <div>
      <div className="form-profile">
        <h2 className="form-profile-title" style={{ fontSize: '20px' }}>Profile</h2>
        <Form noValidate onSubmit={handleEditProfileSubmit}>
          <CustomAlert
            message={alertState.message}
            show={alertState.show}
            variant={alertState.variant}
            closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
          />
          <ChangeMobileNumberModal
            show={showChangeModal}
            setModalShow={setShowChangeModal}
            setPhoneNumber={setPhoneNumber}
            setAlertState={setAlertState}
            oldPhone={phoneNumber}
          />
          <Form.Group className="d-flex flex-column form-group-custom-uploader">
            <Form.Label className="d-flex justify-content-start align-items-start">
              Upload Profile Image
            </Form.Label>
            <FileUploader name="file" types={['JPG', 'PNG']} handleChange={handleUploadProfilePic}>
              <div className="avatar-uploader">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="Icons">
                    <path
                      id="Vector"
                      d="M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H14V8H16V10H21V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM6 17H18L14.25 12L11.25 16L9 13L6 17ZM17 9V7H15V5H17V3H19V5H21V7H19V9H17Z"
                      fill="#0BA9E0"
                    />
                  </g>
                </svg>
              </div>
              {selectedFile && (
                <div className="file-loaded-message">
                  File loaded: {selectedFile.name}
                </div>
              )}
            </FileUploader>
          </Form.Group>
          <Form.Group>
            <Form.Label>Email</Form.Label>
            <Form.Control
              readOnly
              type="email"
              value={email}
              onChange={(evt) => {
                setEmail(evt.target.value);
                setEmailError({ error: false, message: '' });
              }}
              isInvalid={emailError.error}
            />
            <Form.Control.Feedback type="invalid">{emailError.message}</Form.Control.Feedback>
          </Form.Group>
          <Form.Group>
            <Form.Label>Name</Form.Label>
            <Form.Control
              value={firstName}
              onChange={(evt) => {
                const { value } = evt.target;
                setFirstName(value);
                setFirstNameError({ error: false, message: '' });
              }}
              isInvalid={firstNameError.error}
            />
            <Form.Control.Feedback type="invalid">{firstNameError.message}</Form.Control.Feedback>
          </Form.Group>
          <Form.Group>
            <Form.Label>Mobile Number</Form.Label>
            <div className={`phone-number-wrapper ${phoneNumberError.error ? 'error' : ''}`}>
              <PhoneInput
                international
                placeholder="Enter mobile number"
                defaultCountry="MY"
                value={phoneNumber}
                onCountryChange={(_) => isCountryChanged.current = !isCountryChanged.current}
                onChange={(phone) => {
                  if (isCountryChanged.current) {
                    isCountryChanged.current = !isCountryChanged.current;
                    // Get the old phone
                    const { nationalNumber } = parsePhoneNumber(phone_number);
                    // Append it into the value, because the default will be no national_number, then we append it with old phone_number value
                    const updatedPhone = `${phone}${nationalNumber}`;
                    setPhoneNumber(updatedPhone)
                  } else {
                    setPhoneNumber(phone)
                  }
                  setPhoneNumberError({ error: false, message: '' });
                }}
                disabled={true}
              />
              <Button
                variant="ghost"
                style={{
                  minWidth: 145,
                  height: 41,
                  marginLeft: 8,
                  borderRadius: 4,
                }}
                onClick={() => setShowChangeModal(true)}
              >
                Change
              </Button>
            </div>
            <Form.Control.Feedback
              type="invalid"
              className={phoneNumberError.error ? 'd-block' : ''}
            >
              {phoneNumberError.message}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group>
            <Form.Label>Country</Form.Label>
            <Select
              name="country"
              options={country_options}
              value={selected_country}
              onChange={setSelected_country}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Time Zone</Form.Label>
            <Select
              name="timezone"
              options={getTimezone()}
              value={timezone}
              onChange={(value) => setTimezone(value)}
            />
          </Form.Group>
          { !white_label_perkeso && (
            <Form.Group>
              <Form.Label>Default currency</Form.Label>
              <Form.Control
                as="select"
                name="currency"
                value={currency}
                onChange={(e) => setCurrency(e.target.value)}
              >
                <option value="USD">United States Dollars</option>
                <option value="EUR">Euro</option>
                <option value="MYR">Malaysia Ringgit</option>
              </Form.Control>
            </Form.Group>
          ) }
          <Form.Group>
            <Button
              type="submit"
              variant="primary"
              disabled={loadingSave}
              style={{ minWidth: 160 }}
            >
              {loadingSave && <Spinner animation="border" size="sm" className="mr-2" />}
              Save
            </Button>
          </Form.Group>
        </Form>
      </div>
    </div>
  );
};


export default UserProfile
